import React from "react";
import img from "../home page/about images/destress.png";
import { MdDone } from "react-icons/md";
import { BsFillSuitHeartFill } from "react-icons/bs";
import { useResultContext } from "../../../src/app";

import { Link } from "react-router-dom";
function About() {
  const { setactive, active } = useResultContext();

  return (
    <div className="relative">
      <div className="my-[110px] relative items-center phone:block phone:justify-center flex justify-center  ">
        <div className=" relative">
          <img
            src={img}
            alt="img"
            className="space-x-10 m-auto w-[2000px] phone:w-[500px]  demitablet:max-h-[480px] tablet:max-h-[540px]"
          />

          <div className="absolute mdd:top-60  mr-10 border-[1px] border-white bg-white/10 w-[310px] demitablet:w-[250px] backdrop-blur-lg rounded-md top-20 left-0 flex items-center">
            <div className="bg-primary-100 p-2 m-4 rounded-md flex justify-center items-center">
              <MdDone className="bg-white text-primary-100 rounded-full h-8 w-8 p-[7px]" />
            </div>
            <span className="px-2 demitablet:text-[13px]  font-font2 text-gray-900">
              We prioritize customer satisfaction.
            </span>
          </div>
          <div className="absolute border-[1px] border-white phone:right-40 phonex2:right-0 phonex2:top-0  bg-white/10  backdrop-blur-lg rounded-md top-[380px]  demitablet:right-20 right-0 tablet:right-0 flex items-center">
            <BsFillSuitHeartFill className=" text-red-500 phone:right-20 demitablet:h-[50px] phonex2:top-0 demitablet:w-[50px] h-[75px] w-[75px] p-[7px]" />
          </div>
        </div>
        <div className="pl-24 phone:flex phone:flex-col phone:text-center phone:justify-center demitablet:pl-0">
          <h1 className="main-X-titles my-10 font-font1 font-bold">About Us</h1>
          <p className="demitablet:text-[14px]  text-gray-700 pr-[100px] tablet:pr-[0] mb-2">
            {" "}
            At Miracle Essential Oils, , we stand by one fundamental belief:
            essential oils are truly an essential part of life. We realized this
            truth after discovering that for thousands of years, essential oils
            - considered by many as the lifeblood of plants.
          </p>
          <p className="demitablet:text-[14px]  text-gray-700 pr-[100px] tablet:pr-[0]">
            have been used by people across different cultures in a myriad of
            ways, whether it’s fostering physical, mental, or emotional
            well-being, or bringing communities together in the shared pursuit
            of a more natural, holistic approach to health and wellness.
          </p>
          <Link onClick={() => setactive(2)} to="/about-us">
            <button className="py-6  my-10 hover:bg-white hover:text-gray-900 border-2 border-gray-900/0 hover:border-gray-900 duration-700 px-14 font-font1 font-light rounded-md bg-gray-900 text-white">
              Read More
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default About;
